import React from "react";
import ClientLoanOriginationLayout from "@/layouts/clients/client-loan-origination-layout";

function WithLoanOriginationLayout(Page) {
  return function (props) {
    return (
      <ClientLoanOriginationLayout>
        <Page {...props} />
      </ClientLoanOriginationLayout>
    );
  };
}

export default WithLoanOriginationLayout;
